module.exports = __webpack_public_path__ + "media/images/spec_help_1x-2ad57bdb.jpg";